export default __webpack_public_path__ + "static/media/minimize.f3ca4ad5.svg";